export default [
    {
        path: '/dynamic-time-balances',
        name: 'dynamic-time-balances',
        component: () => import ('./views/DynamicTimeBalanceIndex'),
        meta: {
            title: 'Balanceamento de Horário',
            icon: 'mdi-scale-balance',
        }
    },
]